module.exports = __webpack_public_path__ + "static/media/Illus-StoreOpening.c8313ebf.png";